import { useReveal } from "@/hooks/useReveal";

const STEPS = [
  {
    title: "Brief and qualification",
    body: "You tell us product, format, volume and target launch date. We confirm whether it fits our plant before anything else happens.",
    duration: "1 week",
  },
  {
    title: "Samples and specification",
    body: "We send product samples and agree the technical specification in writing.",
    duration: "On request",
  },
  {
    title: "Packaging and artwork",
    body: "You supply artwork to our dieline, or we work with your designer on it. Labelling compliance for your destination market is checked at this stage.",
    duration: "2–4 weeks",
  },
  {
    title: "Pilot run and approval",
    body: "A short pilot run for your sign-off before full production.",
    duration: "2 weeks",
  },
  {
    title: "Production",
    body: "Full run, with certificate of analysis issued per batch.",
    duration: "Quoted on confirmation",
  },
  {
    title: "Export and documentation",
    body: "FOB Cartagena or Buenaventura, with organic certificates, CoA, phytosanitary and pallet documentation.",
    duration: "Per shipping schedule",
  },
];

export default function HowItWorks() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="how-it-works" className="bg-ink py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center max-w-2xl mx-auto">
          <h2 className="text-cream font-serif text-3xl md:text-4xl font-semibold">
            How a private label run works
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {STEPS.map((step, i) => (
            <div key={step.title} className="relative">
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full border border-brand text-brand font-serif text-sm font-semibold">
                  {i + 1}
                </span>
                <span className="h-px flex-1 bg-cream/15 hidden md:block"></span>
              </div>
              <h3 className="mt-4 text-cream font-serif text-lg md:text-xl font-semibold">
                {step.title}
              </h3>
              <p className="mt-2 text-cream/70 text-[17px] leading-relaxed">
                {step.body}
              </p>
              <p className="mt-3 text-brand text-sm font-semibold">
                {step.duration}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}